import React from 'react';
import AssociateTaxWindow from '../Contents/Office/OfficeAdmin/AssociateTaxWindow';
import TaxWindowDescription from '../Contents/Office/OfficeAdmin/TaxWindowDescription';
import InputTypesEnum from '../Enums/InputTypesEnum';
import TaxService from '../Services/TaxService';
import LookupItemService from '../Services/LookupItemService';
import InputWithClear from './InputComponents/InputWithClear';
import ErrorMessage from './ErrorMessage';
import TabOfDataTable from './DataTable/TabOfDataTable';
import TaxItem from '../Domain/TaxItem';
import OrderDirectionsEnum from '../Enums/OrderDirectionsEnum';
import ButtonTypeEnum from '../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../Enums/ButtonColorsEnum';
import IconPositionEnum from '../Enums/IconPositionEnum';
import FigmaButtonRow from './FigmaButtonRow';
import GeneralEditWizzardBase from './GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../Enums/CrudTypesEnum';

export default class TaxComponent extends React.Component {
  static defaultProps = {
    officeId: 1,
    isActiveSlide: true,
    showEdit: false,
    entityTypeId: null,
    entityId: null,
    showAddNewTaxLink: true,
    showRemove: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      window: null,
      showInactiveTaxes: false,
      searchItem: {},
    };
    this.refresh = this.refresh.bind(this);
    TaxItem.activateDeactivate = this.activateDeactivateTaxFunction.bind(this);
    TaxItem.deleteTaxFunction = this.deleteTaxFunction.bind(this);
    TaxItem.isDeleteHidden = this.isDeleteHidden.bind(this);
    TaxItem.editFunction = this.showEditFunction.bind(this);
  }

  refresh = () => this.setState({ searchItem: {} });

  activateDeactivateTaxFunction(tax) {
    let message = tax.Inactive ? 'You are going to activate this tax.' : 'You are going to deactivate this tax.';
    ErrorMessage.SetApprove(message, () => {
      TaxService.ActivateDeactivateTax(tax)
        .then((result) => this.refresh())
        .catch((error) => {
          this.setState({ saving: false });
          ErrorMessage.SetErrorMessage('DTW67');
        });
    });
  }

  deleteTaxFunction(tax) {
    let message = 'You are going to remove this tax.';

    ErrorMessage.SetApprove(message, () => {
      TaxService.DeleteTax(tax.TaxId)
        .then((result) => this.refresh())
        .catch((error) => {
          this.setState({ saving: false });
          ErrorMessage.SetErrorMessage('DTW67');
        });
    });
  }

  isDeleteHidden() {
    return !this.props.showRemove;
  }

  showEditFunction(tax) {
    LookupItemService.GetLookupItemListByLookupId(80)
      .then((result) => {
        const taxesPaidByOptions = result.map((r) => ({ label: r.text, value: r.value, disabled: false }));
        const editedTax = { ...tax, OfficeId: this.props.officeId, TaxesPaidByOptions: taxesPaidByOptions };
        this.setState({
          window: (
            <GeneralEditWizzardBase
              crudType={tax.TaxId ? CrudTypesEnum.Update : CrudTypesEnum.Create}
              editedItem={editedTax}
              clickOnCancel={() => this.setState({ window: null })}
              clickOnSave={() => {
                this.setState({ window: null });
                this.refresh();
              }}
              windowDescription={TaxWindowDescription}
              errorCode='OFF-TAX-EDIT'
            />
          ),
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('TC-TAX-LOOKUP'));
  }

  AssociateTaxFunction() {
    this.setState({
      window: (
        <AssociateTaxWindow
          clickOnCancel={(refresh) => {
            this.setState({ window: null });
            if (refresh) this.refresh();
          }}
          officeId={this.props.officeId}
          entityTypeId={this.props.entityTypeId}
          entityId={this.props.entityId}
        />
      ),
    });
  }

  renderButtons() {
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            iconName: 'fa-solid fa-plus-circle',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.Center,
            onClick: () => (this.props.showEdit ? this.showEditFunction(new TaxItem()) : this.AssociateTaxFunction()),
            tooltip: 'Add New Tax',
          },
        ]}
      />
    );
  }

  getServiceFunction() {
    if (this.props.entityTypeId != 72 && this.props.entityId != -1) {
      return () => TaxService.GetTaxesByEntityTypeIdAndEntityId(this.props.entityTypeId, this.props.entityId);
    }
    return () => TaxService.GetTaxListByOfficeId(this.props.officeId);
  }

  convertDbItem(items) {
    let convertedItems = TaxService.ConvertDBItem(items);
    if (this.state.showInactiveTaxes) return convertedItems;
    return convertedItems.filter((i) => i.Inactive === false);
  }

  render() {
    return (
      <div className=''>
        {this.props.showAddNewTaxLink && !this.state.window ? this.renderButtons() : null}
        <TabOfDataTable
          type={TaxItem}
          serviceFunction={this.getServiceFunction()}
          convertDBItemsFunction={this.convertDbItem.bind(this)}
          searchItem={this.state.searchItem}
          searchParamsType={null}
          orderDirection={OrderDirectionsEnum.Asc}
          showSearchStrip={false}
          clickOnStartSearch={() => {}}
          errorCode='TC248'
        />
        {this.props.isActiveSlide && (
          <InputWithClear
            fieldName={'nevermind'}
            labelText={'Show Inactive Taxes'}
            value={this.state.showInactiveTaxes}
            onChange={(fieldName, newValue) =>
              this.setState({
                showInactiveTaxes: newValue,
                searchItem: { ...this.state.searchItem },
              })
            }
            type={InputTypesEnum.OnOff}
          />
        )}
        {this.state.window}
      </div>
    );
  }
}
